const carFitler = () => {
    const btnCategorieFilter = document.querySelector('#categorie-filter')
    const btnModeleFilter = document.querySelector('#modele-filter')
    const mobileBtnCategorieFilter = document.querySelector('#mobile-categorie-filter')
    const mobileBtnModeleFilter = document.querySelector('#mobile-modele-filter')
    const btnCostSlider = document.querySelector('#cost-filter')
    const categorieList = document.querySelector('.category-list')
    const modeleList = document.querySelector('.series-list')
    const costSlider = document.querySelector('.cost-sldier-container')
    const switchLabelInput = document.querySelectorAll('.switch-label')

    if (switchLabelInput) {

        switchLabelInput.forEach(elem => {
            elem.addEventListener('click', e => {
                const label = e.currentTarget
                label.classList.toggle('actived')
            })
        })
    }



    if(window.matchMedia("(min-width: 1023px)").matches) {
        //Select and open Catégorie liste filter as default
        btnCategorieFilter.classList.add('current')
        categorieList.classList.add('open')

        if (btnModeleFilter) {
            btnModeleFilter.addEventListener('click', e => {
                //Add class when Modèles filter button is clicked
                btnModeleFilter.classList.add('current')
                btnCategorieFilter.classList.remove('current')
                //Open filter list
                modeleList.classList.add('open')
                categorieList.classList.remove('open')
            })
        }

        btnCategorieFilter.addEventListener('click', e => {
            //Add class when Catégories filter button is clicked
            btnCategorieFilter.classList.add('current')
            btnModeleFilter.classList.remove('current')
            //Open filter list
            categorieList.classList.add('open')
            modeleList.classList.remove('open')
        })
    } else {
        if(btnCostSlider) {
            btnCostSlider.addEventListener('click' , e => {
                if(costSlider.classList.contains('open')) {
                    costSlider.classList.remove('open')
                    btnCostSlider.classList.remove('develop')
                }
                else {
                    costSlider.classList.add('open')
                    btnCostSlider.classList.add('develop')
                }
            })
        }

        if (mobileBtnModeleFilter) {
            mobileBtnModeleFilter.addEventListener('click', e => {
                if(modeleList.classList.contains("open")) {
                    modeleList.classList.remove('open')
                    mobileBtnModeleFilter.classList.remove('develop')
                }
                else {
                    modeleList.classList.add('open')
                    mobileBtnModeleFilter.classList.add('develop')
                }
            })
        }

        if (mobileBtnCategorieFilter) {
            mobileBtnCategorieFilter.addEventListener("click", e => {
                if(categorieList.classList.contains('open')) {
                    categorieList.classList.remove('open')
                    mobileBtnCategorieFilter.classList.remove('develop')
                }
                else {
                    categorieList.classList.add('open')
                    mobileBtnCategorieFilter.classList.add('develop')
                }
            })
        }
    }
}

export default carFitler
